import { boot } from 'quasar/wrappers';
import { useAuthStore } from 'stores/useAuthStore';
import { useTokenStorage } from 'src/composables/useTokenStorage';

export default boot(async () => {
  try {
    const authStore = useAuthStore();
    const { getToken } = useTokenStorage();

    const token = await getToken();

    if (token) {
      authStore.token = token;
      try {
        await authStore.fetchMe();
      } catch {
        await authStore.clearAuth();
      }
    }
  } catch (err) {
    console.error('[boot/auth] failed:', err);
  }
});
